import React, { useState, useMemo, useCallback, useEffect } from "react";
import toast from "react-hot-toast";
import { callDeleteApi, callGetApi, callPostApi, callPutApi } from "api/ApiCaller";
import {
    Activate_Ingredient_List_Item_PUT,
    Delete_Ingredient_Deleted_List_Item_DELETE,
    GET_Ingredient_Deleted_List_POST,
    Get_Ingredient_List_Item_GET,
    GET_Ingredient_List_POST,
    Inactivate_Ingredient_List_Item_PUT,
    Revive_Ingredient_List_Item_PUT,
    Get_Ingredient_Fetch_List_Item_GET,
} from "api/ApiConst";
import { API_SUCCESS } from "api/ResponseCodes";
import dateUtilities from "utils/DateUtilities.jsx";
import PaginationDataTable from "components/common/PaginationDataTable";
import IngredientAddEdit from "./IngredientAddEdit";
import { getImageSrcViaRefId } from "utils/UserUtils";
import { PAGE_LOADER } from "utils/constants";
import { useSelector } from "react-redux";
const IngredientMaster = () => {
    const { user } = useSelector((state) => state.user);
    const [record, setRecord] = useState(null);
    const [viewDeletedList, setViewDeletedList] = useState(false);
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [showModal, setShowModal] = useState(null);
    const [recordID, setRecordID] = useState(null);

    useEffect(() => {
        if (!showModal) {
            setRecordID(null);
        }
    }, [showModal]);

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const showOtherUnits = (data) => {
        const _data = data?.map((item) => {
            return item.unit;
        })
        return _data?.join(", ");
    }

    const columns = useMemo(
        () => [
            {
                id: "itemName",
                name: "Item Name",
                selector: (row) => row.itemName,
                sortable: true,
                reorder: true,
            },
            {
                id: "packUnit",
                name: "Pack Unit",
                selector: (row) => (row.packUnit + " [ " + row.packToOpen + " ]"),
                sortable: true,
                reorder: true,
            },
            {
                id: "openUnit",
                name: "Open Unit",
                selector: (row) => (row.openUnit + " [ " + row.openToFractional + " ]"),
                sortable: true,
                reorder: true,
            },
            {
                id: "fractionalUnit",
                name: "Fractional Unit",
                selector: (row) => row.fractionalUnit,
                sortable: true,
                reorder: true,
            },
            {
                id: "otherUnits",
                name: "Other Unit",
                selector: (row) => showOtherUnits(row.otherUnits),
                sortable: true,
                reorder: true,
            },

            // {
            //     id: "createdAtTimeStamp",
            //     name: "Created At",
            //     selector: (row) =>
            //         dateUtilities.formattedDate(
            //             row.createdAtTimeStamp,
            //             "dd-MM-yyyy hh:mm aa"
            //         ),
            //     sortable: true,
            //     reorder: true,
            // },

            // {
            //     id: "modifiedAtTimeStamp",
            //     name: "Modified At",
            //     selector: (row) =>
            //         dateUtilities.formattedDate(
            //             row.modifiedAtTimeStamp,
            //             "dd-MM-yyyy hh:mm aa"
            //         ),
            //     sortable: true,
            //     reorder: true,
            // },
            // {
            //     id: "action",
            //     name: "Action",
            //     style: {
            //         justifyContent: "flex-start",
            //     },
            //     cell: (row) => getActionEvents(row),
            // },
        ],
        [handleRefresh]
    );
    const getActionEvents = (row) => {
        return (
            <div className="dropdown">
                <button
                    className="btn btn-primary btn-sm dropdown-toggle"
                    type="button"
                    id="actionBtn"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    Action button
                </button>
                {viewDeletedList ? (
                    <ul className="dropdown-menu" aria-labelledby="actionBtn">
                        <li onClick={() => handleReviveEvent(row.uuid)}>
                            Revive
                        </li>
                    </ul>
                ) : (
                    <ul className="dropdown-menu" aria-labelledby="actionBtn">
                        {/* <li onClick={() => handleEdit(row.uuid)}>Edit</li> */}

                        <li
                            onClick={() => {
                                row.active
                                    ? handleInactiveEvent(row.uuid)
                                    : handleActiveEvent(row.uuid);
                            }}
                        >
                            {row.active ? "Inactive" : "Active"}
                        </li>
                        {(user && user.userType !== "ADMIN_ASSISTANT") && <li onClick={() => handleDeleteEvent(row.uuid)}>
                            Delete
                        </li>}
                    </ul>
                )}
            </div>
        );
    };

    const handleActiveEvent = (uuid) => {
        callPutApi(
            "loader",
            Activate_Ingredient_List_Item_PUT.replace("{uuid}", uuid),
            record,
            {},
            (res) => {
                if (res.errorCode === API_SUCCESS) {
                    toast.success("Activated Item Successfully");
                    handleRefresh();
                }
            }
        );
    };
    const handleInactiveEvent = (uuid) => {
        callPutApi(
            "loader",
            Inactivate_Ingredient_List_Item_PUT.replace("{uuid}", uuid),
            record,
            {},
            (res) => {
                if (res.errorCode === API_SUCCESS) {
                    toast.success("Deactivated Item Successfully");
                    handleRefresh();
                }
            }
        );
    };

    const handleDeleteEvent = (uuid) => {
        callDeleteApi(
            "loader",
            Delete_Ingredient_Deleted_List_Item_DELETE.replace("{uuid}", uuid),
            {},
            (response) => {
                if (response.errorCode === API_SUCCESS) {
                    //toast.success(response.message);
                    toast.success("Delete Item Successfully");
                    handleRefresh();
                }
            }
        );
    };

    const handleReviveEvent = (uuid) => {
        getRecordItems(uuid);
        callPutApi(
            "loader",
            Revive_Ingredient_List_Item_PUT.replace("{uuid}", uuid),
            record,
            {},
            (res) => {
                if (res.errorCode === API_SUCCESS) {
                    toast.success("Revive Item Successfully");
                    handleRefresh();
                }
            }
        );
    };

    const getRecordItems = (uuid) => {
        callGetApi(
            "loader",
            Get_Ingredient_List_Item_GET.replace("{uuid}", uuid),
            {},
            (res) => {
                setRecord(res.responsePacket);
            }
        );
    };

    const handleEdit = (uuid) => {
        setRecordID(uuid);
        setShowModal(true);
    };

    const handleAddEvent = () => {
        setShowModal(true);
    };
    const handleFetch = () => {
        callPostApi(
            PAGE_LOADER,
            GET_Ingredient_List_POST,
            {},
            {},
            (res) => {
                toast.success(res.message, { id: "handleRefresh1" });
            }
        );
    };

    return (
        <>
            <div className="container-fluid">
                <div className="card shadow mt-3">
                    <div className="text-end p-3 border-bottom d-flex align-content-center justify-content-between ">
                        <div className="page-title-box ">
                            <h4 className="mb-sm-0 font-size-18">Ingredient</h4>
                        </div>
                        <div>
                            {/* {!viewDeletedList && (
                <button
                  className="btn btn-primary me-3"
                  onClick={() => handleAddEvent()}
                >
                  Add
                </button>
              )} */}

                            <button
                                className="btn btn-primary me-3"
                                onClick={() => handleFetch()}
                            >
                                Fetch
                            </button>

                            {/* <div className="btn form-check btn-primary">
                                <input
                                    className="form-check-input ms-0"
                                    type="checkbox"
                                    onChange={() =>
                                        setViewDeletedList(!viewDeletedList)
                                    }
                                    id="flexCheckDefault"
                                />
                                <label
                                    className="form-check-label text-light ps-2"
                                    htmlFor="flexCheckDefault"
                                >
                                    Delete List
                                </label>
                            </div> */}
                        </div>
                    </div>
                    <PaginationDataTable
                        paginationUrl={GET_Ingredient_List_POST}
                        serverSidePagination={false}
                        search={false}
                        pagination={false}
                        columns={columns}
                    />
                </div>
            </div>
            {/* {showModal && (
        <IngredientAddEdit
          show={showModal}
          hideModal={() => setShowModal(false)}
          recordID={recordID}
          handleRefresh={handleRefresh}
        />
      )} */}
        </>
    );
};

export default IngredientMaster;
